<ng-container *transloco="let t">
  <div class="flex items-center gap-2">
    <button
      type="button"
      role="switch"
      [id]="controlId()"
      [attr.aria-checked]="checked()"
      [attr.aria-label]="label() ? null : t(ariaLabel()) || null"
      [attr.aria-required]="required()"
      [attr.aria-busy]="pending()"
      [disabled]="disabled() || pending()"
      [class]="checked() ? 'bg-primary' : 'bg-stroke'"
      class="relative h-6 w-11 rounded-full transition-colors duration-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
      (click)="checked.set(!checked())"
      (blur)="touch.emit()"
    >
      <span
        [class]="checked() ? 'inset-s-5.5' : 'inset-s-0.5'"
        class="absolute top-1/2 h-5 w-5 -translate-y-1/2 rounded-full bg-white shadow transition-all duration-200"
      ></span>
    </button>
    @if (label()) {
    <label [class]="labelClass()" class="text-sm cursor-pointer" [for]="controlId()">
      {{ t(label()) }}
    </label>
    }
  </div>
</ng-container>
